import { domReady, iterateNodes } from './src/dom';

import Accordion from './src/accordion';
import HoverHandler from './src/hover-handler';
import MobileMenu from './src/mobile-menu';
import MoreTextHandler from './src/more-text-handler';
import ScrollAnimations from './src/scroll-animations';
import ScrollHandler from './src/scroll-handler';

export const hoverHandler = new HoverHandler(
  [
    '.link',
    'a',
    '.button',
    'input[type="submit"]',
    'button[type="submit"]',
    '.accordion .label',
    '.indicator-nav .bullet',
    '.slide-next, .slide-prev',
    '.menu.level-1 > .item',
    '.layout-box-shadow > .grid-item',
    '#back-to-top',
    '.-arrow-down',
    '[data-read-more]',
    '.post-preview',
    '.gfield_radio > li',
  ]
);


let init = () => {
  let headerBreakpoint = 1249;
  new MobileMenu(headerBreakpoint, '.header-navigation', 50);

  new Accordion({
    selectors: '.accordion .label'
  });

  if (typeof picturefill !== 'undefined') {
    picturefill();
  }

  new MoreTextHandler({
    selectors: '.row-content > .copy-text [data-section-more]',
    innerReadMore : true
  });

  new MoreTextHandler({
    selectors: '.row-content > .copy-text [data-copy-more]',
    defaultVal : 200
  });

  new ScrollHandler('', 200);
  new ScrollAnimations('section.content-row', 'showElements');

  forceMinimumHeight();
  fixedTableOfContents();
  resizeHeader();
  window.addEventListener('resize', () => {
    forceMinimumHeight();
    resizeHeader();
  });
  window.addEventListener('scroll', () => activeTableOfContentsElement());

  const frontScrollElement = document.querySelector('.-arrow-down'); 
  if (frontScrollElement) {
    frontScrollElement.addEventListener('click', () => {
      let pageHeader = document.getElementById('page-header');
      window.scroll({ left: 0, top: pageHeader.offsetHeight, behavior: 'smooth' });
    });
  }

  if (window.innerWidth < 900) {
    imageElementMobileFirst();
  }
};

domReady(init);
window.addEventListener('load', () => {
  new MoreTextHandler({
    selectors: '.grid-item [data-read-more]',
  });
});

function fixedTableOfContents() {
  let tableOfContents = document.querySelector('.table-of-contents');
  if (!tableOfContents) {
    return;
  }
  new ScrollAnimations('.table-of-contents', 'fixedElement');
  //new ScrollAnimations('.site-header', 'topAnimation');

  let contentsHeader = tableOfContents.querySelector('.header');
  let contentsLinks = tableOfContents.querySelectorAll('a');

  contentsHeader.addEventListener('click', () => {
    tableOfContents.classList.toggle('-open');
  });
  contentsLinks.forEach((el) => {
    el.addEventListener('click', () => {
      tableOfContents.querySelector('.header').click();
    });
  });

  new Accordion({
    'selectors': '.table-of-contents > .header'
  });
}


function activeTableOfContentsElement() {
  iterateNodes('.table-of-contents .content > a', (el) => {
    let currentScroll = document.documentElement.scrollTop;
    let refElementSelector = el.getAttribute('href');
    let refElement = document.querySelector(refElementSelector);

    if (!refElement || !refElement.offsetTop) {
      return;
    }

    if (refElement.offsetTop <= currentScroll) {
      iterateNodes('.table-of-contents .content > a', (link) => {
        link.classList.remove('-active');
      });
      el.classList.add('-active');
    } else {
      el.classList.remove('-active');
    }
  });
}

function forceMinimumHeight() {
  let viewport = window.innerHeight;
  let main = document.querySelector('.site-main');
  let footer = document.querySelector('.site-footer');
  let adminbar = document.getElementById('wpadminbar');

  if (!footer || !main) {
    return;
  }

  let minMainHeight = viewport - footer.getBoundingClientRect().height;
  if (adminbar !== null) {
    let adminbarStyle = window.getComputedStyle(adminbar);

    if (adminbarStyle.display !== 'none') {
      minMainHeight -= 32;
    }
  }

  if (main.getBoundingClientRect().height === minMainHeight) {
    return;
  }

  main.style.minHeight = minMainHeight + 'px';
}

function imageElementMobileFirst() {
  iterateNodes('.content-row > .row-content > .image:nth-child(2)', (node) => {
    let parent = node.parentNode;
    parent.insertBefore(node, parent.childNodes[0]);
  });
}

function resizeHeader() {
  let header = document.querySelector('header');
  let main = document.querySelector('.site-main');
  let headerImage = header.querySelector('.image.background');

  if(!headerImage){
    return;
  }

  header.style.height = 'auto';
  header.style.padding = '1em 0';
  main.style.paddingTop = header.clientHeight + 'px';
}